import React, { useState } from 'react'
import { Breadcrumb, Layout } from 'antd'
import { Content } from 'antd/lib/layout/layout'
import { CardContainer, FormInput, HeaderContainer, Loading, ModalDelete, Table } from 'components'
import { Form, Formik } from 'formik'
import { formatCurrency } from 'utils'
import { IcEdit, IcTrash } from 'assets/icons'
import { ModalCreateUpdateHargaJarak } from './components'
import { useQuery } from 'react-query'
import { apiGet, apiPost, apiPut, apiDelete, urls } from 'api'
import { useDispatch, useSelector } from 'react-redux'
import { metaInitialData, perPageInitialData } from 'constant'
import { logout } from 'store/actions'

const initialModal = {
  show: false,
  type: 'create',
  fromDistance: '',
  toDistance: '',
  price: '',
  id: ''
}
const initialModalDelete = {
  show: false,
  idHargaJarak: '',
  title: '',
  desc: '',
  id: ''
}

const HargaJarakPage = () => {
  const dispatch = useDispatch()
  const user = useSelector((state) => state.auth)
  const [modalDelete, setModalDelete] = useState({ ...initialModalDelete })
  const [modalCreateUpdate, setModalCreateUpdate] = useState({ ...initialModal })
  const [meta, setMeta] = useState(metaInitialData)
  const [perPageArr, setPerPageArr] = useState(perPageInitialData)
  const [isLoadingCRUD, setIsLoadingCRUD] = useState(false)
  const [priceList, setPriceList] = useState([])
  const [currentPage, setCurrentPage] = useState(0)
  const [searchRangePrice, setSearchRangePrice] = useState('')

  const onHandleExtraUrl = () => {
    let extraUrl = ''
    if (searchRangePrice !== '') {
      extraUrl += `&keywords=${searchRangePrice}`
    }

    return extraUrl
  }

  const onLogout = () => dispatch(logout())

  const { isLoading, refetch } = useQuery({
    queryKey: ['range-prices-list'],
    refetchOnWindowFocus: false,
    queryFn: async () =>
      await apiGet({
        url: `${urls.master.location.rangePrice.prefix}/${
          urls.master.location.rangePrice.root
        }?limit=${perPageArr.find((item) => item.selected === true).value}&offset=0`,
        token: user.token,
        onLogout
      }),
    onSuccess: (data) => {
      setPriceList(data.resData.data)
      setCurrentPage(0)
      setMeta(data.resData.meta)
    }
  })

  const onChangePrevNextPage = (offset) => {
    setIsLoadingCRUD(true)
    setMeta({ ...meta, offset })
    const mount = setTimeout(async () => {
      const response = await apiGet({
        url: `${urls.master.location.rangePrice.prefix}/${
          urls.master.location.rangePrice.root
        }?limit=${
          perPageArr.find((item) => item.selected === true).value
        }&offset=${offset}${onHandleExtraUrl()}`,
        token: user.token,
        onLogout
      })
      if (response.resStatus === 200 && response.resData.meta.http_code === 200) {
        setPriceList(response.resData.data)
      } else {
        refetch()
      }
      setIsLoadingCRUD(false)
    })
    return () => clearTimeout(mount)
  }

  const onChangePerPage = (value) => {
    setIsLoadingCRUD(true)
    const newArr = [...perPageArr]
    newArr.map((item) => {
      if (item.value === value) {
        item.selected = true
      } else {
        item.selected = false
      }
    })
    const mount = setTimeout(async () => {
      const response = await apiGet({
        url: `${urls.master.location.rangePrice.prefix}/${
          urls.master.location.rangePrice.root
        }?limit=${value}&offset=0${onHandleExtraUrl()}`,
        token: user.token,
        onLogout
      })
      if (response.resStatus === 200 && response.resData.meta.http_code === 200) {
        setPriceList(response.resData.data)
        setMeta(response.resData.meta)
        setPerPageArr(newArr)
      } else {
        refetch()
      }
      setIsLoadingCRUD(false)
    })
    return () => clearTimeout(mount)
  }

  const fontValueStyle = 'font-medium text-gray-700'

  const columns = [
    {
      name: 'Dari',
      selector: (row) => row.start_distance,
      cell: (row) => <span className={fontValueStyle}>{`${row.start_distance} km`}</span>
    },
    {
      name: 'Hingga',
      selector: (row) => row.end_distance,
      cell: (row) => <span className={fontValueStyle}>{`${row.end_distance} km`}</span>
    },
    {
      name: 'Harga',
      selector: (row) => row.price,
      cell: (row) => <span className={fontValueStyle}>{formatCurrency(row.price)}</span>
    },
    {
      name: 'Action',
      button: true,
      ignoreRowClick: true,
      sortable: false,
      right: true,
      center: true,
      width: '100px',
      cell: (row) => (
        <div className="flex items-center justify-center self-center">
          <div
            className="hover:cursor-pointer p-1 border-solid border border-gray-300 rounded-md mr-2 hover:bg-gray-100"
            onClick={() =>
              setModalCreateUpdate({
                show: true,
                type: 'edit',
                fromDistance: row.start_distance,
                toDistance: row.end_distance,
                price: row.price,
                id: row.id
              })
            }>
            <IcEdit className="text-gray-700" size={16} />
          </div>
          <div
            className="hover:cursor-pointer p-1 border-solid border border-[#FDA19B] rounded-md hover:bg-gray-100"
            onClick={() =>
              setModalDelete({
                show: true,
                idHargaJarak: row.id,
                id: row.id,
                title: 'Hapus Harga Jarak',
                desc: `Apakah anda yakin ingin menghapus harga jarak [${`${row.start_distance} - ${row.end_distance} km`}] ini? Data yang Anda Hapus tidak dapat dipulihkan kembali.`
              })
            }>
            <IcTrash className="text-primary-500" size={16} />
          </div>
        </div>
      )
    }
  ]

  if (isLoading ?? isLoadingCRUD) {
    return <Loading visible={true} />
  }

  return (
    <Layout style={{ padding: 24, background: '#F5F5F5', width: '100%' }}>
      <Breadcrumb style={{ margin: 8 }}>
        <Breadcrumb.Item className="font-inter font-semibold text-gray-700">
          Master Data
        </Breadcrumb.Item>
        <Breadcrumb.Item className="font-inter font-medium text-gray-500">Lokasi</Breadcrumb.Item>
        <Breadcrumb.Item className="font-inter font-medium text-gray-500">
          Harga Jarak
        </Breadcrumb.Item>
      </Breadcrumb>
      <Content style={{ margin: 8 }}>
        {modalDelete.show ? (
          <ModalDelete
            minHeight="min-h-[18%]"
            minWidth="min-w-[18%]"
            maxWidth="max-w-[18%]"
            title={modalDelete.title}
            desc={modalDelete.desc}
            onClose={() => setModalDelete({ ...initialModalDelete })}
            onSubmit={() => {
              setIsLoadingCRUD(true)
              const mount = setTimeout(async () => {
                await apiDelete({
                  url: `${urls.master.location.rangePrice.prefix}/${urls.master.location.rangePrice.root}/${modalDelete.id}`,
                  token: user.token,
                  onLogout
                })
                setModalDelete({ ...initialModalDelete })
                refetch()
                setIsLoadingCRUD(false)
              })
              return () => clearTimeout(mount)
            }}
          />
        ) : null}
        {modalCreateUpdate.show ? (
          <ModalCreateUpdateHargaJarak
            minHeight="min-h-[20%]"
            state={modalCreateUpdate}
            onClose={() => setModalCreateUpdate({ ...modalCreateUpdate, show: false })}
            onSubmit={(values, prices) => {
              setIsLoadingCRUD(true)
              const mount = setTimeout(async () => {
                if (modalCreateUpdate.type === 'create') {
                  await apiPost({
                    url: `${urls.master.location.rangePrice.prefix}/${urls.master.location.rangePrice.root}`,
                    data: {
                      start_distance: parseInt(values.fromDistance),
                      end_distance: parseInt(values.toDistance),
                      price: prices,
                      onLogout
                    },
                    token: user.token
                  })
                }
                if (modalCreateUpdate.type === 'edit') {
                  console.log('hit')
                  await apiPut({
                    url: `${urls.master.location.rangePrice.prefix}/${urls.master.location.rangePrice.root}/${modalCreateUpdate.id}`,
                    data: {
                      start_distance: parseInt(values.fromDistance),
                      end_distance: parseInt(values.toDistance),
                      price: prices,
                      onLogout
                    },
                    token: user.token
                  })
                }
                setModalCreateUpdate({ ...initialModal })
                setIsLoadingCRUD(false)
                refetch()
              })
              return () => clearTimeout(mount)
            }}
          />
        ) : null}
        <CardContainer>
          <div className="flex flex-col w-full space-y-5">
            <HeaderContainer
              isPressAdd
              title="Harga Jarak"
              titleAdd="Tambah Harga Jarak"
              onPressAdd={() =>
                setModalCreateUpdate({ ...modalCreateUpdate, show: true, type: 'create' })
              }
            />
            <Formik
              initialValues={{
                searchHargaJarak: ''
              }}>
              <div className="flex-row w-1/5">
                <FormInput
                  name="searchHargaJarak"
                  placeholder="Pencarian"
                  type="text"
                  isIconLeft
                  iconName="search"
                  onValidate={async (value) => {
                    const response = await apiGet({
                      url: `${urls.master.location.rangePrice.prefix}/${
                        urls.master.location.rangePrice.root
                      }?keywords=${value}&limit=${
                        perPageArr.find((item) => item.selected === true).value
                      }&offset=0`,
                      token: user.token,
                      onLogout
                    })
                    if (response.resStatus === 200 && response.resData.meta.http_code === 200) {
                      setPriceList(response.resData.data)
                      setMeta(response.resData.meta)
                    } else {
                      refetch()
                    }
                    setSearchRangePrice(value)
                  }}
                />
              </div>
            </Formik>
            <Table
              currentPage={meta.offset ? meta.offset + 1 : 1}
              totalPerPage={
                perPageArr.find((item) => item.selected === true).value + (meta.offset ?? 0) >
                meta.total
                  ? meta.total
                  : perPageArr.find((item) => item.selected === true).value + (meta.offset ?? 0)
              }
              dropDownDataFilter={perPageArr}
              lengthAllData={meta.total}
              columns={columns}
              data={priceList}
              onChangePrevPage={() => {
                if (currentPage > 0) {
                  setCurrentPage(currentPage - 1)
                  onChangePrevNextPage(
                    (currentPage - 1) * perPageArr.find((item) => item.selected === true).value
                  )
                }
              }}
              onChangeNextPage={() => {
                if (
                  perPageArr.find((item) => item.selected === true).value + (meta.offset ?? 0) <
                  meta.total
                ) {
                  setCurrentPage(currentPage + 1)
                  onChangePrevNextPage(
                    (currentPage + 1) * perPageArr.find((item) => item.selected === true).value
                  )
                }
              }}
              onChangeDropDown={(value) => onChangePerPage(value)}
            />
          </div>
        </CardContainer>
      </Content>
    </Layout>
  )
}

export default HargaJarakPage
